import logoDark from '../image/logo-dark.svg'
import logoLight from '../image/logo-light.svg'
import logoIcon from '../image/icon.svg'

var config = {}
var default_config = {
  apiGateway: {
    URL: "",
    REGION: ''
  },
  jwt: {
    sign_key: "sign_key_here"
  },
  defaultLanguage: "en",
  fef_ui_version: "dev",
};

var siteConfig = {
  title: 'Wells Financial Partners',
  siteLogo: logoLight,
  siteLogoDark: logoDark,
  siteIcon: logoIcon,
  defaultPage: '/',
  footerText: 'Powered by Four Eyes Financial ©',
  passwordLength: 8,

  defaultTheme: 'light',
};

try {
  var local = require("./config_local.js");

  config = {...default_config, ...local.config}
  siteConfig = {...siteConfig, ...local.siteConfig}

} catch(e) {
 
}

export { config, siteConfig }

